// styles.ts
import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

const toolbarDesktopWidth = '72px';
const toolbarMobileHeight = '72px';
const headerHeight = '65px';

export const styles = (showToolbar = true) => {
  const activeToolbarWidth = showToolbar ? toolbarDesktopWidth : '0px';

  return {
    toolbarContainer: css`
      height: 100%;
      top: 0;
      right: 0;
      bottom: 0;
      position: relative;

      ${breakpoints.down('xs')} {
        height: calc(100% - ${headerHeight});
        position: fixed;
        width: 100%;
        top: ${headerHeight};
        bottom: 0;
        right: 0;
        left: 0;
        max-width: 100%;
        z-index: 9;
      }
    `,
    closed: css`
      display: none;
    `,
    toolbarPanel: css`
      height: 100%;
      width: ${activeToolbarWidth};
      top: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      background-color: var(--cds-color-neutral-background-primary-weak);
      z-index: 2;
      display: ${showToolbar ? 'auto' : 'none'};

      ${breakpoints.down('xs')} {
        position: fixed;
        width: 100%;
        height: ${toolbarMobileHeight};
        top: auto;
        bottom: 0;
        left: 0;
        flex-direction: row;
        justify-content: center;
      }
    `,
    toolbarContent: css`
      height: 100%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      background-color: var(--cds-color-neutral-background-primary-weak);
      z-index: 1;
      min-width: 300px !important;

      ${breakpoints.down('xs')} {
        width: 100%;
        height: 100%;
        bottom: 0;
        top: auto;
        left: 0;
        right: 0;
        border-right: none;
        min-width: 100% !important;
      }
    `,
  };
};
